<template>
  <v-card>
    <v-toolbar
      color="blue darken-3"
      dense
      dark>
      Config
    </v-toolbar>
    <v-list>
      <!-- user links -->
      <v-list-tile
        v-for="item in items"
        v-if="item.visible()"
        :key="item.text"
        :to="item.path">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            {{ item.text }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      items: [
        {
          icon: 'fa-cog',
          text: 'Settings',
          path: '/settings',
          visible: () => this.assertSetting('editSettings', 1)
        },
        {
          icon: 'fa-map',
          text: 'Campground',
          path: '/campgrounds',
          visible: () => this.assertSetting('editConfig', 1)
        },
        {
          icon: 'fa-car',
          text: 'Parking',
          path: '/parkingAreas',
          visible: () => this.assertSetting('editConfig', 1)
        },
        {
          icon: 'fa-briefcase',
          text: 'Commercial Use Permits',
          path: '/CommercialPermits',
          visible: () => this.assertSetting('editConfig', 1)
        }
      ]
    }
  }
}
</script>
